import { useFlags } from 'launchdarkly-react-client-sdk';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { headerWrapperStyle, buttonStyle } from './CepView.styles';
import { mayaCepListRoute } from 'basics/constants/routes.constants';
import { VeevaSyncStatus } from 'basics/enums/maya.enums';
import ButtonsBar from 'components/ButtonsBar';
import {
  FormLayoutContainer,
  FormLayoutMidPanel,
  FormLayoutMidPanelContent,
  FormLayoutMidPanelHeader,
} from 'components/FormLayout';
import Heading from 'components/Heading';
import MayaLayout from 'components/MayaLayout/MayaLayout';
import VeevaStatusBar from 'components/VeevaStatusBar/VeevaStatusBar';
import useCepView from 'routes/AuthenticatedApp/CepView/CepView.hook';
import { CepViewStepsIndex } from 'routes/AuthenticatedApp/CepView/CepView.types';
import CepConfigView from 'routes/AuthenticatedApp/CepView/Steps/CepConfigView/CepConfigView';
import CepGoalView from 'routes/AuthenticatedApp/CepView/Steps/CepGoalView/CepGoalView';
import MiViewPreviewView from 'routes/AuthenticatedApp/CepView/Steps/MiViewPreviewView/MiViewPreviewView';
import TacticsView from 'routes/AuthenticatedApp/CepView/Steps/TacticsView/TacticsView';
import TargetListView from 'routes/AuthenticatedApp/CepView/Steps/TargetListView/TargetListView';
import { ActionButton, ButtonVariant } from 'yoda-ui/components/BiogenLincDS/Buttons';
import Box from 'yoda-ui/components/Box';
import { Icons } from 'yoda-ui/components/Icons/Icon';
import Stepper from 'yoda-ui/components/Stepper/Stepper';

const CepView: FC = () => {
  const { t } = useTranslation();
  const flags = useFlags();
  const {
    buttonsConfig,
    cep,
    navigate,
    handleChangeStep,
    stepIndexer,
    stepsList,
  } = useCepView();

  return (
    <MayaLayout>
      <FormLayoutContainer>
        <FormLayoutMidPanel >
          <FormLayoutMidPanelHeader>
            <Stepper
              handleChangeStep={ handleChangeStep }
              stepsList={ stepsList }
              stepIndex={ stepIndexer.stepIndex }
            />
          </FormLayoutMidPanelHeader>
          <FormLayoutMidPanelContent>
            <ActionButton
              label={ t('actions_back_label') }
              icon={ Icons.arrowBack }
              onClick={ () => { navigate(mayaCepListRoute); } }
              variant={ ButtonVariant.primary }
              sx={ buttonStyle }
            />

            <Box sx={ headerWrapperStyle }>
              <Heading>
                { t('maya_cep_view') }
              </Heading>
              <VeevaStatusBar
                lastVeevaSync={ cep?.lastVeevaSync }
                lastVeevaSyncErrors={ cep?.lastVeevaSyncError ? [cep?.lastVeevaSyncError] : undefined }
                veevaSyncStatus={ cep?.veevaSyncStatus as VeevaSyncStatus }
              />
            </Box>
            {
              stepIndexer.stepIndex === CepViewStepsIndex.configurationStep
                ? (
                  <Box width="100%">
                    <CepConfigView cep={ cep } />
                  </Box>
                )
                : null
            }
            {
              stepIndexer.stepIndex === CepViewStepsIndex.goalStep
                ? (
                  <Box width="100%">
                    <CepGoalView cep={ cep } />
                  </Box>
                )
                : null
            }
            {
              stepIndexer.stepIndex === CepViewStepsIndex.targetListStep
                ? (
                  <Box width="100%">
                    <TargetListView/>
                  </Box>
                )
                : null
            }
            {
              stepIndexer.stepIndex === CepViewStepsIndex.tacticsStep
                ? (
                  <Box width="100%">
                    <TacticsView/>
                  </Box>
                )
                : null
            }
            {
              flags.mayaBdcfcsd714EnableMiViewPreview && stepIndexer.stepIndex === CepViewStepsIndex.miViewPreviewStep
                ? (
                  <Box width="100%">
                    <MiViewPreviewView/>
                  </Box>
                )
                : null
            }
            { buttonsConfig && <ButtonsBar { ...buttonsConfig } /> }
          </FormLayoutMidPanelContent>
        </FormLayoutMidPanel>

      </FormLayoutContainer>
    </MayaLayout>
  );
};

export default CepView;

